export default {
  // Navigation
  'nav.home': 'Home',
  'nav.value': 'Value',
  'nav.industries': 'Industries',
  'nav.contact': 'Contact',
  'nav.available': 'Available',
  'nav.makeOffer': 'Make Offer',
  'nav.premiumDomain': 'Premium Domain',

  // Hero Section
  'hero.exclusiveOffering': 'Exclusive Domain Offering',
  'hero.domainName': 'International Intelligence',
  'hero.tagline': 'A Rare Digital Asset of Exceptional Value',
  'hero.subtagline': 'Commanding presence in intelligence, consulting & strategic sectors',
  'hero.availableNow': 'Available Now',
  'hero.premiumAsset': 'Premium Asset',
  'hero.premiumDomain': 'Premium Domain',
  'hero.exclusiveListing': 'Exclusive Listing',
  'hero.forSale': 'For Sale',
  'hero.trustedTld': 'Trusted TLD',
  'hero.characters': '26 Characters',
  'hero.verifiedOwner': 'Verified Owner',
  'hero.contact': 'Contact',
  'hero.whyThisDomain': 'Why This Domain',
  'hero.commandsAttention': 'Commands Attention',
  'hero.whyDescription': 'Four pillars of value that make this domain an exceptional digital asset for any ambitious organization.',
  'hero.makeOffer': 'Make an Offer',
  'hero.exploreValue': 'Explore Value',
  'hero.discoverMore': 'Discover More',
  'hero.ownership': 'Ownership',
  'hero.ownershipValue': 'Verified & Secured',
  'hero.extension': 'Extension',
  'hero.extensionValue': '.ORG (Trusted)',
  'hero.transfer': 'Transfer',
  'hero.transferValue': 'Immediate',
  'hero.status': 'Status',
  'hero.statusValue': 'Premium Asset',
  'hero.valuePoint1Title': 'Authority & Trust',
  'hero.valuePoint1Desc': 'The .ORG extension carries inherent credibility recognized globally',
  'hero.valuePoint2Title': 'Power Keywords',
  'hero.valuePoint2Desc': '"International" + "Intelligence" — commanding presence in any sector',
  'hero.valuePoint3Title': 'Investment Grade',
  'hero.valuePoint3Desc': 'Premium domains appreciate over time with consistent value growth',
  'hero.valuePoint4Title': 'Instant Transfer',
  'hero.valuePoint4Desc': 'Secure, verified ownership with immediate transfer capability',
  'hero.statTrustedTld': 'Trusted TLD',
  'hero.statPowerKeywords': 'Power Keywords',
  'hero.statIndustryFit': 'Industry Fit',
  'hero.statPotential': 'Potential',
  'hero.statReadyForTransfer': 'For Transfer',

  // Value Proposition
  'value.title': 'Why This Domain Commands Premium Value',
  'value.subtitle': 'Four Core Pillars',
  'value.description': 'Understanding the intrinsic and market value of international-intelligence.org',
  'value.instantAuthority': 'Instant Authority',
  'value.instantAuthorityDesc': 'Command immediate credibility in the intelligence and strategic sectors. This domain speaks power before a single word is read.',
  'value.trustFactor': 'Trust Factor',
  'value.globalRecognition': 'Global Recognition',
  'value.globalRecognitionDesc': 'The .ORG extension paired with "International Intelligence" creates universal trust, memorability, and cross-border appeal.',
  'value.worldwideReach': 'Worldwide Reach',
  'value.investmentGrade': 'Investment Grade',
  'value.investmentGradeDesc': 'Premium keyword combination with strong appreciation potential. Domain values in this category have shown consistent growth.',
  'value.assetValue': 'Asset Value',
  'value.seoDominance': 'SEO Dominance',
  'value.seoDominanceDesc': 'Two powerful keywords that naturally rank for high-value search queries across intelligence, consulting, and technology sectors.',
  'value.searchPower': 'Search Power',

  // Contact Section
  'contact.title': 'Acquire This Domain',
  'contact.heading': 'Ready to Own International Intelligence?',
  'contact.description': 'This premium domain is owned by Bronz Yazılım, a Turkish software company. For serious inquiries, reach us directly through the channels below.',
  'contact.email': 'Email',
  'contact.emailDesc': 'Send us a direct inquiry',
  'contact.emailAction': 'mail@bronzyazilim.com',
  'contact.phone': 'Phone',
  'contact.phoneDesc': 'Call for immediate response',
  'contact.phoneAction': 'Contact via Email',
  'contact.ownerTitle': 'Current Owner',
  'contact.ownerName': 'Bronz Yazılım',
  'contact.ownerDesc': 'Turkish Software Company',
  'contact.trustTitle': 'Verified & Secure',
  'contact.trustDesc': 'Ownership verified through domain registrar. Transfer process is secure and immediate upon agreement.',

  // Footer
  'footer.rights': 'All rights reserved',
  'footer.ownedBy': 'Owned by Bronz Yazılım',
} as const;
